
    import { Component, Vue } from 'vue-property-decorator';
    import Util from '@/lib/util';

    @Component({
        name: "backhome"
    })
    export default class MobileHome extends Vue {
        get userName() {
            return this.$store.state.session.user ? this.$store.state.session.user.name : '';
        }

        // 鼠标悬停效果
        handleMouseOver(event: Event) {
            const target = event.currentTarget as HTMLElement;
            if (target) {
                target.style.transform = 'translateY(-2px)';
                target.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.15)';
            }
        }

        // 鼠标移出效果
        handleMouseOut(event: Event) {
            const target = event.currentTarget as HTMLElement;
            if (target) {
                target.style.transform = 'translateY(0)';
                target.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
            }
        }

        // 跳转到出仓确认页面
        goToOutboundConfirm() {
            this.$router.push({ name: 'packconfirm' });
        }

        goToBatchList() {
            this.$router.push({ name: 'BackStockBatchH5' });
        }

        // 退出登录
        handleLogout() {
            this.$Modal.confirm({
                title: '确认退出',
                content: '确定要退出登录吗？',
                onOk: () => {
                    this.$store.commit('app/logout', this);
                    Util.abp.auth.clearToken();
                    location.reload();
                }
            });
        }

        created() {
        }
    }
